import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const PracticeDescription = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col lg={{ span: 10, offset: 1 }}>
          <div className="text-center mb-5">
            <h2 className="fw-bold display-5">🧪 Automation Testing Practice Hub</h2>
            <p className="text-muted fs-5 mt-3">
              Welcome to your central hub for mastering <b>UI Automation</b> with tools like <b>Selenium</b> and <b>Playwright</b>! Whether you're a beginner or looking to refine your skills, this platform offers free, realistic practice websites to learn <b>manual testing</b>, create effective <b>test cases</b>, and automate UI flows. Dive into hands-on scenarios designed to elevate your <b>web testing</b> and <b>automation testing</b> expertise.
            </p>
          </div>

          <div className="bg-light p-5 rounded-4 shadow border">
            <ul className="list-unstyled">
              <li className="mb-5">
                <Link to="/practice-ecommerece-website" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">🛍️ Practice E-commerce Site for UI Automation</h4>
                </Link>
                <p className="text-muted">
                  <b>Learn UI Automation:</b> Dive into our realistic, dummy e-commerce store built for <b>automation testing</b> practice. Perfect for beginners and experienced testers learning <b>Selenium</b> or <b>Playwright</b>. Master essential skills like:
                  </p>
                  <ul>
                    <li><b>Verifying Product Listings:</b> Ensure accuracy and presentation of items.</li>
                    <li><b>Handling Filters & Pagination:</b> Learn to navigate and test large product catalogs.</li>
                    <li><b>Simulating Cart Operations:</b> Automate adding, removing, and updating items in a shopping cart.</li>
                    <li><b>Checking Total Calculations:</b> Validate pricing and order summaries.</li>
                    <li><b>Completing Checkout Flows:</b> Practice end-to-end automation of the purchase process.</li>
                  </ul>
                  <p>
                  This site helps you master <b>XPath</b>, <b>CSS selectors</b>, and how to handle dynamic content loading common in modern web applications.
                </p>
              </li>

              <li className="mb-5">
                <Link to="/flight-booking-scenarios" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">✈️ Flight Booking Practice for Web Automation Testing</h4>
                </Link>
                <p className="text-muted">
                  <b>Elevate Your Automation Skills:</b> Practice automating complex scenarios on our simulated flight booking application. Ideal for learners of <b>Selenium</b> and <b>Playwright</b>, you'll interact with:
                  </p>
                  <ul>
                    <li><b>Dynamic Search Filters:</b> Automate flight searches based on various criteria.</li>
                    <li><b>Calendar-Based Date Pickers:</b> Learn to handle interactive date selection.</li>
                    <li><b>Real-time Result Updates:</b> Test how to manage asynchronous data loading.</li>
                    <li><b>Modals & Form Submissions:</b> Automate interactions with pop-up windows and submitting booking details.</li>
                    <li><b>Responsive Design Components:</b> Understand how automation adapts to different screen sizes.</li>
                  </ul>
                  <p>
                  This module focuses on mastering AJAX-driven interfaces, dependent dropdowns, and building robust automation scripts for real-world web applications.
                </p>
              </li>

              <li className="mb-5">
                <Link to="/practice-login-form" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">🔐 Login Page Automation Practice for Selenium & Playwright</h4>
                </Link>
                <p className="text-muted">
                  <b>Master Authentication Testing:</b> Our practice login page is designed to help you learn how to automate authentication systems using <b>Selenium</b>, <b>Playwright</b>, and other <b>UI automation</b> tools. Practice:
                  </p>
                  <ul>
                    <li><b>Input Validation:</b> Verify error messages for incorrect entries.</li>
                    <li><b>Real-time Error Messages:</b> Automate the testing of dynamic feedback.</li>
                    <li><b>Invalid Credential Handling:</b> Ensure the system correctly rejects wrong logins.</li>
                    <li><b>Password Visibility Toggles:</b> Learn to interact with and test UI elements that show/hide passwords.</li>
                    <li><b>Successful Login Redirections:</b> Verify navigation after successful authentication.</li>
                  </ul>
                  <p>
                  Strengthen your ability to test security aspects and handle various login scenarios.
                </p>
              </li>

              <li className="mb-5">
                <Link to="/register" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">📝 User Registration Automation: Practice Form Testing</h4>
                </Link>
                <p className="text-muted">
                  <b>Become a Form Automation Expert:</b> Our registration page provides a platform to practice automating complex user registration workflows with <b>Selenium</b> and <b>Playwright</b>. Learn to handle:
                  </p>
                  <ul>
                    <li><b>Validations:</b> Test different input constraints and error messages.</li>
                    <li><b>Form Dependencies:</b> Automate fields that appear or change based on other inputs.</li>
                    <li><b>Password Strength Meters:</b> Verify the functionality and feedback of password security indicators.</li>
                    <li><b>Confirmation Messages & Verification Alerts:</b> Automate the testing of user feedback after submission.</li>
                    <li><b>Multi-Step Form Navigation:</b> Practice automating workflows that span multiple pages.</li>
                  </ul>
                  <p>
                  This module is excellent for practicing edge-case testing, using locators effectively, handling custom data, and navigating intricate web forms.
                </p>
              </li>

              <li className="mb-5">
                <Link to="/practice-forms" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">📋 Mastering Long Form Automation for UI Testing</h4>
                </Link>
                <p className="text-muted">
                  <b>Tackle Complex Web Forms:</b> Our long form automation practice area is specifically designed to help you master automating large and intricate web forms using <b>Selenium</b>, <b>Playwright</b>, and other <b>automation testing</b> frameworks. Learn to interact with:
                  </p>
                  <ul>
                    <li><b>Various Field Types:</b> Text inputs, numbers, dropdowns, checkboxes, file uploads, radio buttons.</li>
                    <li><b>Conditional Logic:</b> Automate based on fields that appear or disappear based on user input.</li>
                    <li><b>Scrolling into View:</b> Handle elements that require scrolling to become visible.</li>
                    <li><b>Dynamic Validation:</b> Test real-time feedback and error messages within long forms.</li>
                    <li><b>User Flow Tracking:</b> Ensure correct navigation and data persistence throughout the form submission process.</li>
                  </ul>
                
              </li>

              <li>
                <Link to="/practice-different-ui-elements" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">🎛️ UI Elements Playground for Selenium and Playwright Practice</h4>
                </Link>
                <p className="text-muted">
                  <b>Explore and Automate Web Components:</b> Our UI Elements Playground offers a dedicated space to practice automating individual web components with <b>Selenium</b> and <b>Playwright</b>. Gain hands-on experience with:
                  </p>
                  <ul>
                    <li><b>Toggles & Switches:</b> Automate interaction and state verification.</li>
                    <li><b>Modals & Pop-ups:</b> Learn to handle and test these interactive elements.</li>
                    <li><b>Tooltips & Hover Effects:</b> Practice automation of elements triggered by mouse interaction.</li>
                    <li><b>Accordions & Carousels:</b> Automate navigation and content verification.</li>
                    <li><b>Tab Navigation:</b> Learn to switch between different content sections.</li>
                    <li><b>Alerts & Notifications:</b> Handle and verify different types of user feedback.</li>
                    <li><b>Dropdowns & Select Lists:</b> Practice selecting options and verifying behavior.</li>
                    <li><b>Sliders & Range Inputs:</b> Automate interaction and value verification.</li>
                  </ul>
                  <p>
                  This playground is ideal for building a strong foundation in verifying element visibility, user feedback mechanisms, and dynamic UI states.
                </p>
              </li>
              <li>
                <Link to="/SeleniumXPathGuide" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">🧭 Learn XPath for Selenium: Practice & Proficiency Test</h4>
                </Link>
                <p className="text-muted">
                  <b>Become an XPath Expert for Web Automation:</b> This dedicated section provides a comprehensive introduction to <b>XPath</b> for <b>Selenium</b> and other <b>UI automation</b> tools. <b>Learn XPath</b> in detail, including:
                  </p>
                  <ul>
                    
                    <li><b>Absolute and Relative Paths:</b> Understand different ways to locate elements.</li>
                    <li><b>XPath Axes & Functions:</b> Master advanced techniques for navigating the DOM.</li>
                    <li><b>XPath Predicates:</b> Learn to use conditions to pinpoint specific elements.</li>
                  </ul>
                  <p>
                  Gain the essential knowledge to precisely locate any UI element, even in complex and dynamic web structures. <b>Test your XPath skills</b> with our integrated MCQ practice exam and ensure you can confidently identify and interact with web elements in your <b>Selenium</b> and <b>Playwright</b> automation scripts.
                </p>
              </li>
              <li>
                <Link to="/forget-password" className="text-decoration-none text-primary fw-bold">
                  <h4 className="text-primary mb-2">🔑 Practice Password Recovery Automation</h4>
                </Link>
                <p className="text-muted">
                <b>This section provides a focused environment to practice automating the password recovery process,</b> essential for UI automation testing.        
                  <br/>
                  <b>Key Automation Skills Covered:</b>
                  </p>
                  <ul>
                    <li><b>Simulated Forgot Password Flow:</b> Practice automating the complete flow, from entering the email to resetting the password.</li>
                    <li><b>XPath Axes & Functions:</b> Master advanced techniques for navigating the DOM.</li>
                    <li><b>Password Reset Automation:</b> Master the steps involved in automating the password reset process.</li>
                  </ul>
                  <p>
             <b>     Enhance your skills in locating UI elements and handling form submissions </b>within password recovery scenarios. This will help you confidently automate similar processes in your<b> Selenium, Cypress, and Playwright automation scripts</b>.
                </p>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PracticeDescription;